import React, { Component } from "react";

import './TimeLine.css';

import $ from 'jquery'; 

import Timeline from "./TimeLine";
import CSRFToken from '../main/csrftoken';

import axios from "axios";
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'
axios.defaults.withCredentials = true;




export default class TimelineTool extends Component {

    constructor(props){
        super(props);
        
        this.study_id = window.location.search.split('=')[1];

        this.excel_file = null;
        this.excel_filename = '';

        this.state = {
            excel_file: this.excel_file,
            excel_filename: this.excel_filename,
            building: true,
            nodes: [],
            edges: [],
            arm_colors: [],
            timeline_warnings: [],
            selected_graph_nodes: [],
            selected_graph_edges: [],
            compare_nodes_list: [],
        }

        if (window.location.search != '') {
            axios
            .post("/api_kb/csv_to_json/"+window.location.search)
            .then((response) => {

                this.setState({
                    building:false,
                    nodes: response.data.nodes[0],
                    edges: response.data.edges[0],
                    arm_colors: response.data.arm_colors,
                    timeline_warnings: response.data.timeline_warnings,
                    selected_graph_nodes: response.data.nodes[0].combined_graph,
                    selected_graph_edges: response.data.edges[0].combined_graph,
                })

            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                    console.log("server responded");
                } else if (error.request) {
                    console.log("network error");
                } else {
                    console.log(error);
                }
            });
        }
    }


    highlightPath = (path, pathselected, color) => {

        document.querySelectorAll(path).forEach(path => {
      
          if (path.classList.contains(pathselected)) {
      
            path.classList.remove(pathselected);
      
            // if arm colors by another pathselected, revert to that color
            var hasPathSelected = false;
            var otherPathSelected = ''
            for (var c = 0; c < path.classList.length ; c ++){
              if (path.classList[c].startsWith('path-selected')) {
                hasPathSelected = true;
                otherPathSelected = path.classList[c];
              }
            }
            
            if (hasPathSelected){
              // get color of otherPathSelected
              var strokeColor = '#b1b1b7'
              this.state.arm_colors.map(color => {
                if (color.arm_id_normalized === otherPathSelected.split('path-selected-')[1]) {
                  strokeColor = color.arm_color;
                }
              })
      
              path.style.stroke = strokeColor;
              path.style.strokeWidth = '5px';
              path.style.strokeDasharray = 'none !important';
            }
      
            else {
              // otherwise reverse to normal color
              path.style.stroke = '#b1b1b7';
              path.style.strokeWidth = '1px';
              path.style.strokeDasharray = '5px';
            }
          }
      
          else {
      
            path.classList.add(pathselected);
            // color path in arm color
            path.style.stroke = color;
            path.style.strokeWidth = '5px';
            path.style.strokeDasharray = 'none !important';
          }
      
        });
      
    };


    handleSubmit = (e) => {

        const formData = new FormData();
        const file = e.target.elements.myfile.files[0];
        const filename = file.name.split('.')[0];

        formData.append("study_timeline", file);

        if (file) {
            this.setState({ 
                excel_file: file,
                excel_filename: filename,
             }); // Store the file in state
        }

        // reset timeline
        this.setState({
            building:true,
        })

        axios
            .post("/api_kb/csv_to_json/"+window.location.search, formData)
            .then((response) =>{

                this.setState({
                    building:false,
                    nodes: response.data.nodes[0],
                    edges: response.data.edges[0],
                    arm_colors: response.data.arm_colors,
                    timeline_warnings: response.data.timeline_warnings,
                    selected_graph_nodes: response.data.nodes[0].combined_graph,
                    selected_graph_edges: response.data.edges[0].combined_graph,
                })

                // display timeline
                // $('#timeline-uploaded')[0].style.display = 'block';
                // $('#spot-timeline')[0].style.display = 'none';

            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                    console.log("server responded");
                } else if (error.request) {
                    console.log("network error");
                } else {
                    console.log(error);
                }
            });

        e.preventDefault();

    };


    updateTimelineDb = (id) => {
    
        // remove class currently displayed timeline show the selected timeline
        document.getElementsByClassName('timeline-displayed')[0].classList.remove('timeline-displayed');
        document.getElementsByClassName('selected-timeline-tab')[0].classList.remove('selected-timeline-tab');

        $('#timeline-'+id).addClass('timeline-displayed');
        $('#'+id).addClass('selected-timeline-tab');
        
    }


    handleCompareNodes = (list) => {
        this.setState({
            compare_nodes_list:list,
        })
    }


    render(){

        return (
            <div className="TimelineTool container">

                <div className="timeline-title-page">
                    Study timeline visualization
                </div>

                { window.location.search == '' ?
                
                    <div className="import-btn">

                        <form onSubmit={this.handleSubmit}>

                            <CSRFToken />
                            
                            <label for="myfile">
                                Select a .xlsx file to visualize a study timeline.
                                <br/>
                                <i>The file needs to contain 3 tabs: planned_event, arm and arm_2_planned_event.</i>
                            </label>
                            <br/>
                            <input type="file" id="myfile" name="study_timeline"/>
                            <input className="btn-submit-tmeline" type="submit" value="Build Timeline"/>

                        </form>

                    </div>

                    : ''
                
                }

                { this.state.building ?
                    
                    <div id="spot-timeline">
                        The study timeline will be displayed here.
                    </div>
                    
                    :
                
                    <div id="timeline-uploaded">

                        <div id="displayed-timeline">

                            <div className="timeline-tabs">

                                <div id="combined-graph" className="arm-tab selected-timeline-tab" onClick={() => this.updateTimelineDb('combined-graph')}>
                                    <p>combined graph</p>
                                </div>

                                { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 
                    
                                    this.state.arm_colors.map(arm => (
                                        <div id={arm.arm_id_normalized} className="arm-tab" onClick={() => this.updateTimelineDb(arm.arm_id_normalized)}>
                                            <p> {arm.arm_id} </p>
                                        </div>
                                    ))

                                    :
                                    
                                    ''

                                }
                            
                            </div>
                            
                            <Timeline id="timeline-combined-graph" export={true} excel_file={this.state.excel_file} excel_filename={this.state.excel_filename} study_id={this.study_id} compare_nodes_list={this.state.compare_nodes_list} compare_nodes_callback={this.handleCompareNodes} display={true} nodes={this.state.selected_graph_nodes} edges={this.state.selected_graph_edges} arm_colors={this.state.arm_colors} />
                            
                            { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 
                                
                                this.state.arm_colors.map(arm => (
                                    <Timeline id={"timeline-"+arm.arm_id_normalized} export={true} excel_file={this.state.excel_file} excel_filename={this.state.excel_filename} study_id={this.study_id} compare_nodes_list={this.state.compare_nodes_list} compare_nodes_callback={this.handleCompareNodes} display={false} nodes={this.state.nodes[arm.arm_id]} edges={this.state.edges[arm.arm_id]} arm_colors={this.state.arm_colors} />
                                ))

                                :
                                
                                ''

                            }

                        </div>

                        <div className="row">

                            <div className="col-6">

                                <div className="box-info">

                                { (this.state.arm_colors !== undefined && this.state.arm_colors.length > 0) ? 
                    
                                    this.state.arm_colors.map(arm => (
                                        
                                        <div className="arm-title-box">
                                            <input type="checkbox" id={"checkbox"+arm.arm_id_normalized} name={"checkbox"+arm.arm_id_normalized} onClick={() => { this.highlightPath('.color-'+arm.arm_id_normalized+' path', 'path-selected-'+arm.arm_id_normalized, arm.arm_color) }}/>
                                            <label for={"checkbox"+arm.arm_id_normalized}>
                                                <u style={{ textDecorationColor: arm.arm_color, textDecorationThickness:'2px' }}>
                                                    {arm.arm_id} - {arm.arm_name}
                                                </u> : 
                                                <i> {arm.arm_description}</i>
                                            </label>
                                        </div>

                                    ))

                                    : 
                                    
                                    ''
                                
                                }

                                </div>

                            </div>

                            <div className="col-6">

                                { (this.state.compare_nodes_list.length > 1) ?

                                    <a className="box-info compare-nodes-action" href={"/query/results/?planned_visits="+this.state.compare_nodes_list.join('+')}>
                                        Compare
                                        <p>Planned visits to compare: {this.state.compare_nodes_list.join(', ')}</p>
                                    </a>
                                    
                                    : ''
                                }

                                <div className="box-info">

                                { (this.state.timeline_warnings !== undefined && this.state.timeline_warnings.length > 0) ? 
                    
                                    this.state.timeline_warnings.map(w => (
                                        
                                        <div>
                                            <p>
                                                {w.warning}
                                            </p>
                                        </div>

                                    ))

                                    : 
                                    
                                    <p>No warnings</p>
                                
                                }

                                </div>

                            </div>

                        </div>
                    </div>
                
                }
                
            </div>
        );
    }
}